import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import useAmplitudeScaleSliderVisible from "@/common/hooks/preferences/useAmplitudeScaleSliderVisible.ts";

function useKeyboardShortcutAmplitudeScaleSliderVisible() {
  const [amplitudeScaleSliderVisible, setAmplitudeScaleSliderVisible] = useAmplitudeScaleSliderVisible();

  useKeyboardListener((event) => {
    if (event.altKey) {
      if (event.key === "å") {
        event.preventDefault();
        setAmplitudeScaleSliderVisible(!amplitudeScaleSliderVisible);
      }
    }
  });

  return null;
}

export default useKeyboardShortcutAmplitudeScaleSliderVisible;
